var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5531 6.74669L5.32879 14.971C5.14126 15.1585 5.0359 15.4129 5.0359 15.6781V18.5065C5.0359 19.0588 5.48362 19.5065 6.0359 19.5065H8.86433C9.12954 19.5065 9.3839 19.4012 9.57143 19.2137L17.7958 10.9893M13.5531 6.74669L15.6425 4.6573C16.033 4.26678 16.6662 4.26678 17.0567 4.6573L19.8851 7.48573C20.2757 7.87625 20.2757 8.50942 19.8851 8.89994L17.7958 10.9893M13.5531 6.74669L17.7958 10.9893",
    stroke: "#131314",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18.5,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.68aa4a1686f59a4c1f3106954aeb9bc8.svg";
export { ForwardRef as ReactComponent };